module.exports = __webpack_public_path__ + "static/media/your-turn.baa234b0.ogg";